import $ from 'jquery';
window.jQuery = window.$ = $;

function escapeHtml(s) {
  if (!s) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

$(window).on('load', function() {
  var delaySpeed = 200;
  var fadeSpeed = 700;

  // メディア一覧：ハッシュ（#2026, #2025, #all）に応じて該当JSONのみ読み込み（キャッシュあり）
  var MEDIA_ROOT = '/static/docs/hare/pages/media/';
  var MEDIA_IMG_BASE = MEDIA_ROOT + 'assets/images/visual/';
  var MEDIA_CP_BASE = 'https://www.dot-st.com/hare/cp/';
  var mediaCache = {};

  function getHash() {
    var h = (location.hash || '#2026').replace('#', '') || '2026';
    return h;
  }

  function getMediaJsonPath(hash) {
    if (hash === 'all') return MEDIA_ROOT + 'assets/data/media.json';
    if (/^20\d{2}$/.test(hash)) return MEDIA_ROOT + 'assets/data/media-' + hash + '.json';
    return MEDIA_ROOT + 'assets/data/media.json';
  }

  function loadMediaData(hash) {
    if (mediaCache[hash]) return Promise.resolve(mediaCache[hash]);
    var path = getMediaJsonPath(hash);
    return fetch(path)
      .then(function(r) { return r.ok ? r.json() : Promise.reject(new Error(r.statusText)); })
      .then(function(items) {
        mediaCache[hash] = items;
        return items;
      });
  }

  function renderMediaItems(items) {
    var $ul = $('#display ul');
    $ul.empty();
    (items || []).forEach(function(item) {
      var date = item.date ? escapeHtml(item.date) : '&nbsp;';
      var href = item.href.indexOf('http') === 0 ? item.href : MEDIA_CP_BASE + item.href;
      var imgSrc = item.imgSrc.indexOf('/') === 0 || item.imgSrc.indexOf('http') === 0 ? item.imgSrc : MEDIA_IMG_BASE + item.imgSrc;
      $ul.append(
        '<li class="' + item.class + '">' +
          '<a class="over" href="' + escapeHtml(href) + '" target="_blank">' +
          '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(item.imgAlt) + '" />' +
          '\n              ' + item.label + '\n              ' +
          '<h3>' + escapeHtml(item.title) + '</h3>\n              ' +
          date +
          '</a></li>'
      );
    });
  }

  function loadAndRenderThenInit(hash) {
    loadMediaData(hash)
      .then(renderMediaItems)
      .then(runAfterMediaReady)
      .catch(function(err) {
        console.warn('media load failed:', err);
        runAfterMediaReady();
      });
  }

  // 初回：現在のハッシュ用のJSONだけ取得して描画
  loadAndRenderThenInit(getHash());

  function runAfterMediaReady() {
    // ハッシュ切り替え（#2024, #2025, #all など）
    function applyHash() {
      var hash = getHash();
      var sel = '#display [class~="' + hash + '"]';
      $('html,body').animate({scrollTop: 0}, 200);
      $('#display ul li, #display h2').css('display', 'none');
      $(sel).each(function(i) {
        $(this).delay(i * delaySpeed).css({
          display: 'block',
          opacity: '0'
        }).animate({opacity: '1'}, fadeSpeed);
      });
    }
    // ハッシュ変更時：該当年度のJSONを取得（未キャッシュなら）→描画→表示切り替え
    window.addEventListener('hashchange', function() {
      var hash = getHash();
      loadMediaData(hash)
        .then(renderMediaItems)
        .then(applyHash)
        .catch(function(err) {
          console.warn('media load failed:', err);
          applyHash();
        });
    });
    applyHash();

    // スクロールでふわっと表示
    (function initScrollAnim() {
    var items = document.querySelectorAll('.anim');
    if (!items.length) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('active');
        });
      },
      { rootMargin: '0px 0px -5% 0px', threshold: 0 }
    );
    items.forEach(function (el) { observer.observe(el); });
    })();

    //ヘッダー固定 PCのみ
    if (!navigator.userAgent.match(/(iPhone|iPod|Android)/)) {
    $(window).scroll(function() {
      var topbar = $('#header').height();
      if ($(window).scrollTop() > topbar) {
        $('#header').css({
          'position': 'fixed',
          'top': '0',
          'left': '0',
          'padding': '0',
          'background': 'rgba(250, 248, 246, .9)'
        });
        $('#header #navi h1').addClass('scr');
      } else {
        $('#header').css({
          'position': 'relative', 'background': 'none', 'padding': '65px 0 0 0'
        });
        $('#header #navi h1').removeClass('scr');
        $('#topicsList').css({'position': 'relative', 'top': '0'});
      }
    });
    }

    // SP メニュータップ後モーダル閉じる（remodal 読み込み時のみ）
      if (typeof $.fn.remodal === 'function') {
      $('#navi-sp ul li').on('click', function() {
        $('[data-remodal-id=menu]').remodal().close();
      });
    }

    // ストアビジュアル フェード（4秒ごとにループ）
    (function initStoreVisual() {
    var container = document.getElementById('store-visual');
    if (!container) return;
    var imgs = container.querySelectorAll('img');
    if (imgs.length === 0) return;
    var n = imgs.length;
    var idx = 0;
    setInterval(function() {
      imgs[idx].classList.remove('is-current');
      idx = (idx + 1) % n;
      imgs[idx].classList.add('is-current');
    }, 4000);
    })();

    //スクロールするとふわっと表示
    function updateBtnTotop() {
    if ($(window).scrollTop() > 200) {
      $('#btn-totop').fadeIn('slow');
    } else {
      $('#btn-totop').fadeOut('slow');
    }
  }
    $(window).scroll(updateBtnTotop);
    updateBtnTotop(); // 初期表示時もスクロール位置で表示を合わせる

    // スクロール
    $('.anchor a').on('click', function() {
    var speed = 400;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - 0;
    $('body, html').animate({scrollTop: position}, speed, 'swing');
    return false;
    });

    // ホバーエフェクトは .over で CSS 制御（sample2 同様）→ JS 不要

    // ドロワー開閉（ネイティブ）
    (function initDrawer() {
    var drawer = document.getElementById('drawer');
    var overlay = document.getElementById('drawer-overlay');
    if (!drawer) return;
    function close() { drawer.classList.remove('drawer-open'); }
    function toggle() { drawer.classList.toggle('drawer-open'); }
    var toggleBtn = document.querySelector('.drawer-toggle');
    if (toggleBtn) toggleBtn.addEventListener('click', toggle);
    if (overlay) overlay.addEventListener('click', close);
    drawer.querySelectorAll('.drawer-menu-close, .drawer-dropdown-menu-item').forEach(function(el) {
      el.addEventListener('click', close);
    });
    })();

    // イヤーセレクト（SP 600px以下でトグル）
    (function initYearSelect() {
    function sp_menu() {
      var w = parseInt($(window).width(), 10);
      if (w <= 600) $(this).toggleClass('active_sp');
    }
    $('#js_cat').on('click', sp_menu);
    })();
  }
});
